import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, CalendarCheck } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { scrollToId } from "../constants";

export const FAQS = [
  {
    q: "Welche Objekte reinigt EMT-Reinigung?",
    a: "Wir reinigen ausschließlich gewerbliche Objekte: Büros, Praxen, Kanzleien, Ladenlokale, Gewerbeimmobilien, Treppenhäuser, Wohnanlagen sowie Baustellen. Private Haushalte betreuen wir nicht.",
  },
  {
    q: "In welchem Gebiet sind Sie tätig?",
    a: "Unser Einsatzgebiet ist Lehrte und die umliegende Region Hannover. Als lokale Reinigungsfirma sind wir schnell vor Ort und flexibel erreichbar.",
  },
  {
    q: "Wie läuft eine Anfrage ab?",
    a: "In drei Schritten: Sie senden Ihre Anfrage telefonisch, per WhatsApp oder über das Formular. Wir vereinbaren eine kostenlose Objektbesichtigung vor Ort. Anschließend erhalten Sie ein individuelles Angebot für Ihr Objekt.",
  },
  {
    q: "Was kostet eine Reinigung?",
    a: "Das hängt von Objektgröße, Leistungsumfang und Reinigungsintervall ab. Nach der kostenlosen Objektbesichtigung erhalten Sie ein transparentes, auf Ihr Objekt zugeschnittenes Angebot.",
  },
  {
    q: "Kann die Reinigung außerhalb unserer Geschäftszeiten stattfinden?",
    a: "Ja. Reinigungszeiten stimmen wir individuell mit Ihnen ab – passend zu Ihrem betrieblichen Ablauf, auch früh morgens oder nach Feierabend.",
  },
  {
    q: "Wir sind mit unserer aktuellen Reinigungsfirma unzufrieden. Wie aufwendig ist ein Wechsel?",
    a: "Ein Wechsel ist unkompliziert: Nach Ihrer Anfrage besprechen wir bei einer kostenlosen Besichtigung Ihren Bedarf und erstellen ein Angebot. Sie entscheiden dann in Ruhe – unverbindlich und ohne Risiko.",
  },
];

export const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-white py-16 md:py-24" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Chapter number="05" label="Häufige Fragen" />
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-ink max-w-2xl">
            Antworten auf häufige Fragen
          </h2>
        </Reveal>

        <div className="mt-12 max-w-3xl">
          {FAQS.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <Reveal key={i} delay={Math.min(i * 0.05, 0.25)}>
                <div
                  className={`border rounded-2xl mb-4 transition-colors duration-300 ${
                    isOpen ? "border-brand/40 bg-surface" : "border-gray-200 bg-white"
                  }`}
                  data-testid={`faq-item-${i + 1}`}
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                    aria-expanded={isOpen}
                    data-testid={`faq-question-${i + 1}`}
                  >
                    <h3 className="font-heading text-base sm:text-lg font-medium text-ink">{item.q}</h3>
                    <ChevronDown
                      className={`w-5 h-5 text-brand shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="px-6 pb-6 text-sm sm:text-base text-mutedtext leading-relaxed" data-testid={`faq-answer-${i + 1}`}>
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-5">
            <p className="text-sm sm:text-base text-mutedtext">Ihre Frage war nicht dabei? Wir beraten Sie gerne persönlich.</p>
            <button
              onClick={() => scrollToId("kontakt")}
              className="inline-flex items-center gap-2.5 rounded-full bg-conv hover:bg-conv-dark text-white font-semibold px-7 py-3.5 text-sm transition-all duration-200 hover:scale-[1.03] shrink-0"
              data-testid="faq-cta-besichtigung"
            >
              <CalendarCheck className="w-4 h-4" />
              Kostenlose Objektbesichtigung vereinbaren
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
